import { useMemo } from 'react';
import usePlayback from 'src/hooks/usePlayback';
import useUI from 'src/hooks/useUI';
import { UserEventTriggerType } from 'src/interfaces/Datahub';
import OptionsControl from 'src/themes/cosmos/components/OptionsControl';

const PlaybackRateControlContainer = () => {
  const { hideSettings } = useUI();
  const { playbackRate, setPlaybackRate, playbackRateOptions } = usePlayback();

  const playbackRateOptionsParse = useMemo(
    () =>
      playbackRateOptions.map((item) => ({
        ...item,
        value: item.rate,
      })),
    [playbackRateOptions],
  );

  return (
    <OptionsControl
      selectedOptionValue={playbackRate}
      onChange={(rate) => {
        hideSettings();
        setPlaybackRate(rate as number, UserEventTriggerType.CLICK);
      }}
      options={playbackRateOptionsParse}
    />
  );
};

export default PlaybackRateControlContainer;
